import { THEME_PART_KEYS, THEME_PARTS, type ThemePartKey } from '@mediardex/contracts'
import type { IconType } from 'react-icons'
import { MdCallToAction, MdPalette, MdSell, MdViewQuilt, MdWebAsset } from 'react-icons/md'

const PART_ICONS: Record<ThemePartKey, IconType> = {
    style: MdPalette,
    frame: MdViewQuilt,
    header: MdWebAsset,
    footer: MdCallToAction,
    productCard: MdSell,
}

interface PartListProps {
    /** Parte aberta no painel da direita, ou `null`. */
    currentPart: ThemePartKey | null
    onSelect: (part: ThemePartKey) => void
}

/**
 * Partes da loja (estilo, moldura, cabeçalho, rodapé, card de produto): valem para todas as páginas. A
 * lista sai do esquema comum (`THEME_PARTS`), então parte nova aparece aqui sozinha.
 */
export default function PartList({ currentPart, onSelect }: PartListProps) {
    return (
        <div className="flex flex-col gap-2">
            <span className="px-1 text-xs font-semibold uppercase tracking-wide text-base-content/60">Aparência</span>
            {THEME_PART_KEYS.map((part) => {
                const Icon = PART_ICONS[part] ?? MdPalette
                const selected = currentPart === part
                return (
                    <button
                        key={part}
                        type="button"
                        className={`flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-sm ${selected ? 'bg-primary/10 font-medium text-primary' : 'hover:bg-base-200'}`}
                        onClick={() => onSelect(part)}
                    >
                        <Icon className="text-base" />
                        {THEME_PARTS[part].label}
                    </button>
                )
            })}
        </div>
    )
}
